import { registerPin } from '@/api/server/user/create';
import { useNavigate } from 'react-router-dom';

import RandomKeypad from '@/component/common/random-keypad';
import SecretNumberDisplay from '@/component/common/secret-number-display';
import SFStepper from '@/component/common/sf-stepper';
import TopBackButton from '@/component/common/top-back-button';
import { SFPalette } from '@/lib/color';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { usePinInfo } from '@/store/zustand/store';
import { updatePin } from '@/api/server/user/update';
import ErrorRes from '@/api/server/ErrorRes';

export default function PinSetting() {
  const navigate = useNavigate();
  const [secretNumber, setSecretNumber] = useState('');
  const [secretNumberConfirm, setSecretNumberConfirm] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const pinInfo = usePinInfo();

  useEffect(() => {
    if (secretNumber && secretNumberConfirm && secretNumber === secretNumberConfirm) {
      (async () => {
        const payload = {
          bf_pin_num: pinInfo.pinNum,
          pin_num: secretNumberConfirm,
        };
        const re = await updatePin(payload);
        if (re.ret_code !== 200) {
          ErrorRes({ code: re.ret_code, msg: re.msg, path: 'PinSetting', isBack: false });
          setSecretNumber('');
          setSecretNumberConfirm('');
          setIsConfirmed(false);
          return;
        }
        toast.success('성공');
        navigate('/authLevel');
      })();
    } else if (secretNumber.length === 6 && secretNumberConfirm.length === 6 && secretNumber !== secretNumberConfirm) {
      toast.error('핀번호가 일치하지 않습니다.');
      initStatus();
    }

    return () => {};
  }, [secretNumber, secretNumberConfirm]);

  const initStatus = () => {
    setIsConfirmed(false);
    setSecretNumber('');
    setSecretNumberConfirm('');
  };

  const onSuccess = () => {
    setIsConfirmed(true);
  };

  return (
    <Container maxWidth="sm">
      <TopBackButton title="PIN 번호 재설정" />
      <Box pt={4}>
        {isConfirmed ? (
          <>
            <Typography variant="h4" mb={2.5}>
              <b>PIN번호 6자리</b>를
              <br />
              다시 입력해 주세요.
            </Typography>
          </>
        ) : (
          <Typography variant="h4" mb={5}>
            <br />
            <b>PIN번호 6자리</b>를 입력해 주세요.
          </Typography>
        )}
        <SecretNumberDisplay value={isConfirmed ? secretNumberConfirm : secretNumber} />
        <Box position="absolute" bottom={0} left={0} mb={2}>
          <RandomKeypad
            value={isConfirmed ? secretNumberConfirm : secretNumber}
            onChange={isConfirmed ? setSecretNumberConfirm : setSecretNumber}
            onSuccess={onSuccess}
          />
        </Box>
      </Box>
    </Container>
  );
}
